// Longlist is the everyday document. Pin usable longlist templates; everything
// else (CV, report, interview, …) sits behind "more templates".

export function partitionTemplates(templates) {
  const pinned = [];
  const rest = [];
  for (const t of templates) {
    if (t.purpose === "longlist" && t.hasFile) pinned.push(t);
    else rest.push(t);
  }
  if (pinned.length === 0) {
    const fallback = templates.filter((t) => t.purpose === "longlist");
    if (fallback.length > 0) {
      return {
        pinned: fallback,
        rest: templates.filter((t) => t.purpose !== "longlist"),
      };
    }
    return { pinned: templates, rest: [] };
  }
  return { pinned, rest };
}
